module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/nb_hours_selection/Large-7926090cbc565fc004088f9a5b1ea448.svg";